export default {
    updateTotalPage(state, payload) {
        state.TotalInfo = payload;
    },
    updateCategory(state, payload) {
        state.Category = payload;
    },
    updateCategories(state, payload) {
        state.Categories = payload;
    },
}